<template>
  <section class="xml-content">
    <header v-html="headerXml"></header>
    <div class="switch-lang">
      <!-- <img
        src="https://sophon-assets.sophon.cn/sophon-prod-s3/assets/images/language-icon.png"
        alt=""
      />

      <span class="cn" @click="switchLang">
        {{ $store.state.lang === "zn" ? "中文" : "English" }}</span
      > -->
    </div>
  </section>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
@Component({ components: {} })
export default class Form extends Vue {
  mounted() {
    this.handleHeaderJs();
  }
  switchLang(language) {
    const lang = this.$store.state.lang;
    if (language !== lang) {
      this.$store.dispatch("updateLang", { lang: language, i18n: this.$i18n });
    }
    if (this.$route.query.lang) {
      language = language === "zn" ? "CN" : "EN";
      this.$router.replace({ query: { lang: language } });
    }
    //  this.$i18n.locale = lang
    //  localStorage.setItem(lang)
  }
  get headerXml() {
    return this.$store.state.headerXml;
  }
  handleHeaderJs() {
    /*dropdown menu*/
    let self = this;
    var $header = $("header");
    var fullDropdownTimer;
    var dropdownDownTimer = {};
    var productTimer;
    function fullDropdownClose(target) {
      $(".head-menu-dropdown-item" + "." + target).hide();
      $(".sophon-btn-full-toggle[data-target=" + target + "]").removeClass(
        "sophon-btn-toggle-hover"
      );
    }

    function fullDropdownOpen(target) {
      var $target = $(".head-menu-dropdown-item" + "." + target);
      $target.stop(true, true).slideDown(200);
      $(".sophon-btn-full-toggle[data-target=" + target + "]").addClass(
        "sophon-btn-toggle-hover"
      );
      clearTimeout(fullDropdownTimer);
    }

    $("header").on("click", ".dropdown-toggle-link", function () {
      if ($(this).attr("href")) {
        window.location.href = $(this).attr("href");
      }
    });

    $("header").on(
      "mouseenter",
      ".head-menu-dropdown-menu-tab-title",
      function (e) {
        if (e.target.classList.contains("mall-tab")) {
          return;
        }
        var dataTarget = $(this).attr("data-target");
        $(".head-menu-dropdown-menu-tab-title.second").removeClass(
          "active-color"
        );
        $(
          `.head-menu-dropdown-menu-tab-title.second[data-target=${dataTarget}]`
        ).addClass("active-color");
        if (!$("#" + dataTarget).is(":visible")) {
          $(".head-menu-dropdown-menu-tab-content").hide();
          clearTimeout(productTimer);
          productTimer = setTimeout(function () {
            $("#" + dataTarget).fadeIn();
          }, 150);
        }
      }
    );

    $("header").on(
      "mouseleave",
      ".head-menu-dropdown-menu-tab-title",
      function () {}
    );

    $("header").on("mouseenter", ".sophon-btn-full-toggle", function () {
      var target = $(this).attr("data-target");
      if (target === "product-dropdown") {
        fullDropdownClose("practice-dropdown");
        fullDropdownOpen(target);
        $(".head-menu-dropdown-menu-tab-content").hide();
        $(".mall-content").hide();
        $(".mall-tab").removeClass("active-color");
        $(".head-menu-dropdown-menu-tab-title").removeClass("active-color");
        $(
          ".head-menu-dropdown-menu-tab-title[data-target=mall-product]"
        ).addClass("active-color");
        $("#mall-product").fadeIn();
        $("#tab-central-city").fadeIn();
        $(
          ".head-menu-dropdown-menu-tab-title[data-target=tab-central-city]"
        ).addClass("active-color");
      } else {
        fullDropdownClose("product-dropdown");
        fullDropdownOpen(target);
      }
    });

    $("header").on("mouseleave", ".sophon-btn-full-toggle", function () {
      var target = $(this).attr("data-target");
      fullDropdownTimer = setTimeout(function () {
        fullDropdownClose(target);
      }, 150);
    });

    $("header").on("mouseenter", ".head-menu-dropdown-item", function () {
      clearTimeout(fullDropdownTimer);
    });

    $("header").on("mouseleave", ".head-menu-dropdown-item", function () {
      $(this).slideUp(200);
      $(
        ".sophon-btn-full-toggle[data-target=" +
          $(this).attr("data-toggle") +
          "]"
      ).removeClass("sophon-btn-toggle-hover");
    });

    $("header").on("mouseenter", ".sophon-hover-toggle", function () {
      var id = $(this).attr("id");
      $(this).find(".dropdown-menu").first().stop(true, true).slideDown(150);
      $(this).addClass("open-menu");
      clearTimeout(dropdownDownTimer[id]);
    });

    $("header").on("mouseleave", ".sophon-hover-toggle", function () {
      var id = $(this).attr("id");
      var $target = $(this).find(".dropdown-menu").first();
      dropdownDownTimer[id] = setTimeout(function () {
        $target.stop(true, true).hide();
        $(".sophon-hover-toggle").removeClass("open-menu");
      }, 150);
    });

    $(document).on("tap", function (e) {
      if (
        !$(e.target).is(".header-menu-navigation-item a") &&
        !$(e.target).is(
          ".header-menu-navigation-item .glyphicon-menu-down-small"
        )
      ) {
        $("#navbar").collapse("hide");
      }
      if (
        !$(e.target).is(".dropdown-toggle") &&
        !$(e.target).is($(".head-menu-dropdown-item")) &&
        !$(e.target).is($(".product-dropdown-image")) &&
        !$(e.target).is($(".product-dropdown-title")) &&
        !$(e.target).is($(".head-menu-dropdown-menu-tab-title")) &&
        !$(e.target).is(".glyphicon-menu-right")
      ) {
        $(".head-menu-dropdown-item").slideUp(200);
        $(".sophon-btn-full-toggle").removeClass("sophon-btn-toggle-hover");
      }
    });

    /*mobile dropdown menu*/
    // var $mobileDropdown = $('.mobile-dropdown')
    $("header").on("show.bs.dropdown", function () {});
    $("header").on("show.bs.dropdown", ".mobile-dropdown", function () {
      $(this).find(".dropdown-menu").first().stop(true, true).slideDown(200);
    });

    $("header").on("hide.bs.dropdown", ".mobile-dropdown", function () {
      $(this).find(".dropdown-menu").first().stop(true, true).slideUp(200);
    });

    $("header").on("show.bs.collapse", function (e) {
      if (!e.target.classList.contains("second-ul")) {
        $(this)
          .parent(".header-menu-navigation-item")
          .addClass("collapse-open");
        $(this)
          .parent(".footer-menu-navigation-item")
          .addClass("collapse-open");
      } else {
        $(this).parent(".second-menu").addClass("collapse-open");
      }
    });

    $("header").on("hide.bs.collapse", function (e) {
      if (!e.target.classList.contains("second-ul")) {
        $(this)
          .parent(".header-menu-navigation-item")
          .removeClass("collapse-open");
        $(this)
          .parent(".footer-menu-navigation-item")
          .removeClass("collapse-open");
      } else {
        $(this).parent(".second-menu").removeClass("collapse-open");
      }
    });

    var $body = $("body");
    $body.on("show.bs.collapse", "#navbar-mobile", function (e) {
      var languageLink = $(".language-select ");
      languageLink.attr("href", "");
      // 使用.on()方法监听点击事件
      languageLink.eq(0).on("click", function (event) {
        // 在这里执行点击事件触发时的操作
        self.switchLang("zn"); //this指向当前DOM,无法调用函数
        // switchLang 方法执行完成后执行后续代码

        location.reload(true);
        window.scroll(0, 0);
        event.preventDefault();
        // 添加您的其他代码或操作
      });
      languageLink.eq(1).on("click", function (event) {
        // 在这里执行点击事件触发时的操作
        self.switchLang("en"); //this指向当前DOM,无法调用函数
        // switchLang 方法执行完成后执行后续代码
        location.reload(true);
        window.scroll(0, 0);
        event.preventDefault();
        // 添加您的其他代码或操作
      });
      if (e.target.id === "navbar-mobile") {
        $("header").css({
          height: "100%",
          "overflow-y": "scroll",
        });
        $body.addClass("disable");
      }
    });
    $body.on("hidden.bs.collapse", "#navbar-mobile", function (e) {
      if (e.target.id === "navbar-mobile") {
        $("header").css({
          height: "auto",
          "overflow-y": "auto",
        });
        $body.removeClass("disable");
      }
    });
    /*position footer*/
    var $container = $("#container");
    var winHeight = $(window).height();
    var containerHeight = $container.height();
    var headerHeight = $header.height();
    var footerHeight = $("footer").height();

    if (winHeight - headerHeight - footerHeight > containerHeight) {
      $container.animate(
        {
          "min-height": winHeight - headerHeight - footerHeight - 1,
        },
        200
      );
    }
    $("body").on("click", function (e) {
      if (
        $(e.target).hasClass("customer-hover-action") ||
        $(e.target).hasClass("customer-hover-box") ||
        $(e.target).closest(".customer-hover-action").length > 0 ||
        $(e.target).closest(".customer-hover-box").length > 0
      ) {
        return;
      }
      $(".customer-hover-box").hide();
    });
    $(window).on("resize", function () {
      winHeight = $(window).height();
      if (winHeight - headerHeight - footerHeight > containerHeight) {
        $container.animate(
          {
            "min-height": winHeight - headerHeight - footerHeight - 1,
          },
          200
        );
      }
    });
    var mallTimer;
    $("header").on("mouseenter", ".mall-tab", function () {
      var mallTarget = $(this).attr("data-target");
      if (!$("#" + mallTarget).is(":visible")) {
        $(".mall-content").hide();
        $(".head-menu-dropdown-menu-tab-content").hide();
        $(".mall-tab").removeClass("active-color");
        $(".head-menu-dropdown-menu-tab-title").removeClass("active-color");
        clearTimeout(mallTimer);
        mallTimer = setTimeout(function () {
          $("#" + mallTarget).fadeIn();
          $(
            `#${mallTarget} .head-menu-dropdown-menu-tab-content:nth-child(2)`
          ).fadeIn();
          $(
            `#${mallTarget} .head-menu-dropdown-menu-tab-item:first-child .head-menu-dropdown-menu-tab-title`
          ).addClass("active-color");
        }, 150);
      }
    });
  }
}
</script>
<style lang="scss" src="./dist/bootstrap.scss"></style>
<style lang="scss" src="./dist/common.scss"></style>
<style lang="scss" src="./dist/font-min.scss"></style>
<style lang="scss" scoped>
.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:hover,
.open > .dropdown-toggle.btn-default,
.open > .dropdown-toggle.btn-default.focus,
.open > .dropdown-toggle.btn-default:hover {
  color: #497bfd;
  background-color: #fff;
  border: none;
  outline: 0;
}
.switch-lang {
  position: fixed;
  right: 50px;
  top: 0;
  z-index: 10000;
  width: 100px;
  height: 86px;
  line-height: 86px;
}

.cn {
  margin-left: 5px;
}
.sophgo-button {
  display: inline-block;
  padding: 8px 24px;
  border: 1px solid #4684f7;
  filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0.043));
  border-radius: 4px;
  transition: all 0.3s ease;
  color: #4684f7;
  cursor: pointer;
}

.sophgo-button.active,
.sophgo-button:hover {
  color: #fff;
  background-color: #4684f7;
}

.dropdown-menu {
  min-width: 180px;
  border-radius: 0;
  border: none;
  left: 50%;
  top: 86px;
  right: auto;
  text-align: center;
  transform: translate(-50%, 0);
  margin: 0;
  padding: 0;
  overflow: inherit;
}

.head-menu-dropdown-menu-tab-content-list {
  display: flex;
  flex-wrap: wrap;
}

.dropdown-menu:before {
  content: " ";
  position: absolute;
  left: 50%;
  margin-left: -6px;
  top: -13px;
  width: 0;
  height: 0;
  border-width: 8px 6px 6px 6px;
  border-style: solid;
  border-color: transparent transparent #fff;
}

.dropdown-menu-inner {
  padding: 0 14px;
}

.dropdown-menu-inner li:not(:last-child) {
  border-bottom: 1px solid #eee;
}

.dropdown-menu-inner > li > a {
  font-size: 14px;
  padding: 14px 0;
  display: block;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
}

.dropdown-menu-inner > li > a:hover {
  color: #497bfd;
}

.dropdown-toggle:hover {
  color: #497bfd;
}

.navbar-collapse {
  padding: 0;
}

header {
  color: #000;
  background-color: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  border-bottom: 1px solid #e3e3e3;
}

.navbar {
  margin: 0 auto;
  border: none;
  border-radius: 0;
}

#navbar {
  position: relative;
  top: 0;
  right: 0;
  left: auto;
  float: left;
  padding-top: 32px;
  margin: 0 0 0 142px;
  z-index: 100;
}

.english #navbar {
  margin: 0 0 0 120px;
}

.navbar .container-fluid {
  display: block;
  margin: 0 auto;
}

.header-menu-shopcart {
  float: right;
  font-size: 16px;
  padding-top: 32px;
  margin-right: 17px;
}

.header-menu-shopcart .sophon-btn-toggle {
  display: inline-block;
  padding-right: 10px;
  color: #707070;
}

.dropdown-shopcart-num:before {
  content: "(";
}

.dropdown-shopcart-num:after {
  content: ")";
}

.dropdown-shopcart.dropdown-menu {
  width: 296px;
  transform: translate(0, 0);
  right: 0;
  left: auto;
  color: #4a4a4a;
}

.dropdown-shopcart.dropdown-menu:before {
  left: 90%;
}

.dropdown-shopcart.dropdown-menu .col-lg-3,
.dropdown-shopcart.dropdown-menu .col-lg-6,
.dropdown-shopcart.dropdown-menu .col-lg-9,
.dropdown-shopcart.dropdown-menu .col-md-3,
.dropdown-shopcart.dropdown-menu .col-md-6,
.dropdown-shopcart.dropdown-menu .col-md-9,
.dropdown-shopcart.dropdown-menu .col-sm-3,
.dropdown-shopcart.dropdown-menu .col-sm-6,
.dropdown-shopcart.dropdown-menu .col-sm-9 {
  padding: 0;
  text-align: left;
}

.dropdown-shopcart.dropdown-menu .dropdown-menu-inner {
  padding: 0;
}

.dropdown-shopcart.dropdown-menu .dropdown-shopcart-list {
  border-top: none;
  border-left: 1px solid #ececec;
  border-right: 1px solid #ececec;
  max-height: 364px;
  overflow-y: auto;
}

.dropdown-shopcart.dropdown-menu ul li {
  padding: 15px 0;
  margin: 0 15px;
}

.dropdown-shopcart.dropdown-menu ul li:not(:last-child) {
  border-bottom: 1px solid #efefef;
}

.dropdown-shopcart-product-image img {
  border: 1px solid #efefef;
  max-width: 60px;
}

.dropdown-shopcart-product-content.col-lg-9.col-md-9.col-sm-9 {
  text-align: left;
  height: 60px;
}

.dropdown-shopcart-product-title {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}

.dropdown-shopcart-product-title h5 {
  font-size: 12px;
}

.dropdown-shopcart.dropdown-menu .dropdown-shopcart-product-detail.col-lg-6,
.dropdown-shopcart.dropdown-menu .dropdown-shopcart-product-detail.col-md-6,
.dropdown-shopcart.dropdown-menu .dropdown-shopcart-product-detail.col-sm-6 {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  text-align: right;
  padding-right: 14px;
  font-size: 12px;
  white-space: nowrap;
}

.dropdown-shopcart-product-total-num {
  text-align: left;
}

.dropdown-shopcart-product-total-price {
  background-color: #f7f7f7;
  text-align: left;
  padding: 15px;
  font-size: 12px;
}

.dropdown-shopcart-product-total-price-detail {
  font-size: 18px;
  color: #d0021b;
  position: relative;
  left: -2px;
}

.dropdown-shopcart-product-total-price-num {
  color: #d0021b;
  font-size: 14px;
}

.dropdown-shopcart-link-container {
  text-align: right !important;
}

.dropdown-shopcart-link {
  padding: 10px 35px;
  display: block;
  float: right;
  white-space: nowrap;
}

.dropdown-shopcart-empty {
  padding: 30px 20px;
}

.header-menu {
  max-width: 1200px;
  height: 86px;
  display: block;
  margin: 0 auto;
}

.header-menu-navigation {
  padding: 0 10px 0 10px;
  height: auto;
  float: left;
}

.header-menu-navigation-item {
  float: left;
  margin: 0 15px;
  font-size: 16px;
}

.english .header-menu-navigation-item {
  margin: 0 10px;
}

.header-menu-navigation-item a {
  color: #000;
}

.nav > li.header-menu-navigation-item > a:hover {
  background: 0 0;
  color: #3371ff;
}

.header-menu-locale .dropdown-toggle:hover,
.header-menu-navigation-item .dropdown-menu .dropdown-menu-active a,
.header-menu-navigation-item .dropdown-toggle:hover,
.header-menu-navigation-item a:hover,
.header-menu-navigation-item.active .dropdown-toggle,
.header-menu-navigation-item.active .dropdown-toggle-link,
.header-menu-navigation-item.sophon-btn-toggle-hover .sophon-btn-toggle,
.header-menu-user .dropdown-toggle:hover,
.sophon-btn-toggle-container.open .sophon-btn-toggle {
  color: #3371ff;
}

.header-menu-navigation-item:last-child {
  margin-right: 0;
}

.header-menu-navigation-item.header-login {
  margin-right: 5px;
}

.header-menu-navigation-item.header-signup {
  margin-left: 5px;
}

.sophon-hover-toggle .dropdown-menu {
  top: 54px;
}

.logo-container {
  position: absolute;
  top: 23px;
  left: 0;
}

.logo {
  max-width: 112px;
}

.header-menu-locale {
  padding-top: 32px;
  float: right;
}

.header-menu-locale .glyphicon-menu-down-small {
  transition: all ease 0.3s;
}

.header-menu-locale.open .glyphicon-menu-down-small {
  transform: rotate(180deg);
}

.header-menu-user {
  padding-top: 32px;
  margin-right: 14px;
  float: right;
}

.header-menu-user:after {
  content: "|";
  color: #8f9095;
}

.header-menu-user .sophon-btn-toggle {
  padding: 0 10px 0 0;
}

.shop-cart-icon-small {
  margin-top: -3px;
}

.head-menu-dropdown {
  box-shadow: 0 4px 10px -3px rgba(0, 0, 0, 0.3);
}

.head-menu-dropdown-item {
  display: none;
  z-index: 1000;
  padding-bottom: 50px;
  background-color: #fff;
  border-top: 1px solid #e4e4e4;
}

.english .head-menu-dropdown-menu {
  min-height: 400px;
}

.practice-dropdown {
  min-height: auto;
}

.head-menu-dropdown-menu {
  max-width: 1200px;
  min-height: 350px;
  display: block;
  margin: 0 auto;
  padding: 20px 0;
  text-align: center;
}

.head-menu-dropdown-menu-item {
  float: left;
  width: 25%;
}

.head-menu-dropdown-menu-item .dropdown-title .glyphicon {
  font-size: 18px;
  margin-right: 10px;
}

.head-menu-dropdown-menu .dropdown-title {
  white-space: nowrap;
  font-size: 16px;
  color: #000;
  font-weight: 500;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 18px;
  line-height: 22px;
}

.english .head-menu-dropdown-menu .dropdown-title {
  font-size: 14px;
}

.head-menu-dropdown-menu .dropdown-list {
  margin-top: 15px;
}

.head-menu-dropdown-menu .practice-list-item {
  padding: 0 9px;
  cursor: pointer;
}

.head-menu-dropdown-menu .dropdown-product-title {
  padding: 14px 0;
  cursor: pointer;
}

.head-menu-dropdown-menu
  .dropdown-product-title:nth-last-child(1)
  .product-list {
  height: 250px;
}

.head-menu-dropdown-menu .dropdown-list-item .dropdown-list-thumbnail {
  max-width: 40px;
}

.english .head-menu-dropdown-menu .dropdown-list-item .dropdown-list-thumbnail {
  display: none;
}

.head-menu-dropdown-menu .dropdown-list-item a {
  font-size: 14px;
  color: #000;
  font-weight: 400;
  margin-left: 10px;
}

.english .head-menu-dropdown-menu .dropdown-list-item a {
  font-size: 12px;
  margin-left: 0;
}

.product-list {
  display: none;
}

.product-list .product-item {
  margin: 10px 0;
}

.head-menu-dropdown-menu .dropdown-list-item a:hover {
  color: #497bfd;
}

.head-menu-dropdown-menu .practice-list-item .practice-dropdown-title {
  font-size: 14px;
  line-height: 22px;
  margin-top: 12px;
  font-weight: 400;
  opacity: 0.7;
}

.head-menu-dropdown-menu .dropdown-list-item .practice-dropdown-image {
  max-width: 420px;
}

.head-menu-dropdown-menu-tab {
  float: left;
  width: 10%;
}

.head-menu-dropdown-menu-tab.en {
  width: 18%;
}

.head-menu-dropdown-menu-tab-title {
  color: #000;
  text-align: right;
  padding: 20px 0;
  font-size: 16px;
}

.head-menu-dropdown-menu-tab-title .glyphicon {
  padding-left: 15px;
  font-size: 14px;
}

.head-menu-dropdown-menu-tab-title:hover {
  color: #497bfd;
}

.head-menu-dropdown-menu-tab-content {
  float: left;
  width: 75%;
  display: none;
  padding-left: 45px;
}

.head-menu-dropdown-menu-tab-content.en {
  width: 67%;
}

.head-menu-dropdown-menu-tab-content-item {
  float: left;
  width: 25%;
  text-align: left;
  margin-bottom: 2px;
}

#mall-solutions .head-menu-dropdown-menu-tab-content-item {
  width: 33%;
}

.head-menu-dropdown-menu-tab-content-title {
  font-size: 14px;
  text-align: left;
  color: #000;
  padding: 20px 0;
}

.head-menu-dropdown-menu-tab-content-thumbnail {
  float: left;
  width: 20%;
  max-width: 45px;
}

.head-menu-dropdown-menu-tab-content-drescription {
  float: left;
  width: 80%;
  padding: 10px 10px 2px;
}

.head-menu-dropdown-menu-tab-content-drescription p {
  color: rgba(0, 0, 0, 0.3);
  font-size: 12px;
  padding-top: 10px;
}

footer {
  background-color: #f5f7fa;
  color: #000;
  width: 100%;
}

.footer-home {
  font-size: 16px;
  padding: 24px 0;
  border-bottom: 1px solid #e5e6e8;
}

.footer-home-inside {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-content {
  padding: 26px 0;
}

.footer-content-item {
  width: 18%;
  float: left;
}

.footer-contact {
  width: 28%;
}

.footer-container-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: block;
}

.footer-content-title {
  margin-bottom: 10px;
  font-size: 16px;
  color: #0e1726;
}

.footer-content-list-item {
  margin-bottom: 8px;
}

.footer-content-list-link {
  font-size: 14px;
  padding: 5px 0;
  color: #4b5159;
}

.footer-icon-list-item {
  float: left;
  font-size: 20px;
  margin-right: 10px;
}

.footer-content-subtitle {
  min-width: 60px;
  text-align: left;
  float: left;
}

.english .footer-content-subtitle {
  min-width: 60px;
}

.footer-content-contact-us {
  margin-left: 12px;
  float: left;
}

.footer-content-contact-us .footer-content-list-link {
  color: #82868e;
  padding: 0;
  display: block;
}

.footer-content-subtitle-follow-us {
  margin-top: 4px;
}

.footer-content-follow-us {
  margin-left: 12px;
  float: left;
}

.footer-copyright {
  background-color: #eceff3;
  font-size: 14px;
}

.footer-icon-list-link .glyphicon {
  opacity: 0.6;
}

.footer-icon-list-link:hover .glyphicon {
  color: #000;
  opacity: 1;
}

.footer-copyright-inside {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 16px 0;
}

.product-detail-link {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #4273f6;
  padding-left: 12px;
  float: left;
}

.status-tag {
  display: inline-block;
  color: #fff;
  font-size: 12px;
  padding: 3px 3px 2px 3px;
  border-radius: 0 7px 0 7px;
  line-height: 12px;
  text-align: right;
  white-space: nowrap;
  background-color: #ce332d;
}

.product-price {
  text-align: left;
  display: inline-block;
  padding: 0 10px 0 7px;
}

.developer-ul-list {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}

.developer-ul {
  border-right: 1px solid #e3e3e3;
  margin-right: 5%;
  padding-right: 8%;
}

.developer-ul:last-child {
  border-right: unset;
  padding-right: unset;
}

.developer-li {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3.6% 0 0;
  line-height: 40px;
  font-size: 16px;
  white-space: nowrap;
}

.developer-li:not(:first-child) a {
  color: rgba(0, 0, 0, 0.6);
}

.developer-li:hover a {
  color: #497bfd;
}

.developer-li:first-child {
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  color: #000;
  margin-bottom: 20px;
  word-break: keep-all;
  white-space: nowrap;
  cursor: default;
}

.developer-menu .head-menu-dropdown-menu {
  min-height: unset !important;
}

.second-ul {
  padding-left: 15px;
}

.mall-category {
  float: left;
  width: 15%;
}

.active-color,
.active-color a {
  color: #4684f7;
}

.mall-solutions-content {
  display: none;
}

@media (max-width: 767px) {
  .logo-container {
    left: 15px;
  }

  .footer-home {
    padding: 24px 20px;
  }

  .footer-container-inner {
    padding: 0 20px;
  }

  .footer-copyright {
    padding: 0 20px;
  }

  .logo-container img {
    max-width: 120px;
  }

  .shopcart-mobile-icon {
    position: absolute;
    right: 70px;
    top: 29px;
  }

  .shopcart-mobile-icon span {
    font-size: 20px;
    line-height: 24px;
    color: #000;
  }

  .navbar-toggle {
    float: right;
    margin: 26px 5px;
  }

  .navbar-toggle .icon-bar {
    background-color: #000;
  }

  .navbar-mobile {
    height: 100%;
  }

  .collapse.in {
    display: block;
  }

  .header-menu-navigation {
    padding: 0 15px;
    width: 100%;
    border-top: 1px solid #e3e3e3;
  }

  .header-menu-navigation .nav,
  .header-menu-navigation-user {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }

  .header-menu-navigation-item {
    width: 100%;
    margin: 0;
  }

  .header-menu-navigation-item .collapse-btn,
  .header-menu-navigation-item a,
  .nav > li > a {
    padding: 20px 0;
    font-size: 16px;
    line-height: 20px;
    display: block;
  }

  .header-menu-navigation-item .collapse-btn {
    position: relative;
  }

  .header-menu-navigation-item .glyphicon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    transition: transform 0.3s ease;
  }

  .header-menu-navigation-item.collapse-open .collapse-btn .glyphicon,
  .second-menu.collapse-open .second-menu-btn .glyphicon {
    transform: rotate(180deg) translate(0, 50%);
  }

  .header-menu-navigation-item.collapse-open .collapse-btn,
  .second-menu.collapse-open .second-menu-btn {
    color: #497bfd;
  }

  .header-menu-navigation-item a {
    padding: 15px;
  }

  .header-menu-navigation-service {
    padding-bottom: 30px;
  }

  .header-menu-navigation-user {
    padding-top: 30px;
  }

  .footer-nav {
    padding: 0 15px;
    width: 100%;
  }

  .footer-menu-navigation-item {
    display: block;
    font-size: 12px;
    border-bottom: 1px solid #e2e4e7;
    margin: 0;
    position: relative;
  }

  .footer-item-title {
    display: block;
    position: relative;
    line-height: 42px;
    color: #000;
  }

  .footer-item-title:hover {
    color: #000;
  }

  .footer-menu-navigation-item .glyphicon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    transition: transform 0.3s ease;
  }

  .footer-menu-navigation-item.collapse-open .glyphicon {
    transform: rotate(180deg) translate(0, 50%);
  }

  .footer-menu-navigation-item ul li a {
    padding: 0 16px;
    margin: 0 16px;
    font-size: 10px;
    line-height: 34px;
    color: rgba(0, 0, 0, 0.7);
  }

  .footer-icon-list {
    text-align: center;
    padding: 5px;
  }

  .footer-icon-list-item {
    display: inline-block;
    float: none;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .header-menu-item {
    margin: 0 7px;
  }

  .header-menu-navigation-item {
    margin: 0 15px;
  }

  .english .head-menu-dropdown-menu .dropdown-title {
    font-size: 12px;
  }
}

@media (min-width: 768px) and (max-width: 1245px) {
  .head-menu-dropdown-menu {
    padding: 30px 2%;
  }

  .header-menu {
    padding: 0 2%;
  }

  .logo-container {
    left: 2%;
  }

  .footer-container {
    padding: 0 15px;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .english .header-menu-navigation-item.tablet-hidden {
    display: none;
  }
}

@media (min-width: 992px) and (max-width: 1160px) {
  .header-menu-item {
    margin: 0 10px;
  }
}

@media (min-width: 768px) and (max-width: 966px) {
  .header-menu-item:first-child {
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .is-mobile .navbar-toggle {
    float: right;
    margin: 18px 5px;
    display: block;
  }

  .is-mobile .navbar-toggle .icon-bar {
    background-color: #fff;
  }

  .is-mobile .navbar-toggle {
    float: right;
    margin: 18px 5px;
  }

  .is-mobile .navbar-toggle .icon-bar {
    background-color: #fff;
  }

  .is-mobile .navbar-mobile {
    height: 100%;
  }

  .is-mobile .collapse.in {
    display: block;
  }

  .is-mobile .header-menu-navigation {
    padding: 0 15px;
    width: 100%;
  }

  .is-mobile .header-menu-navigation .nav {
    max-width: 1200px;
    margin: 0 auto;
  }

  .is-mobile .header-menu-navigation .nav,
  .is-mobile .header-menu-navigation-user {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }

  .is-mobile .header-menu-navigation-item {
    width: 100%;
    margin: 0;
  }

  .is-mobile .header-menu-navigation-item .collapse-btn,
  .is-mobile .header-menu-navigation-item a,
  .is-mobile .nav > li > a {
    padding: 20px 0;
    font-size: 16px;
    line-height: 20px;
    display: block;
  }

  .is-mobile .header-menu-navigation-item .collapse-btn {
    position: relative;
  }

  .is-mobile .header-menu-navigation-item .glyphicon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    transition: transform 0.3s ease;
  }

  .is-mobile
    .header-menu-navigation-item.collapse-open
    .collapse-btn
    .glyphicon,
  .second-menu.collapse-open .second-menu-btn .glyphicon {
    transform: rotate(180deg) translate(0, 50%);
  }

  .header-menu-navigation-item.collapse-open .collapse-btn,
  .second-menu.collapse-open .second-menu-btn {
    color: #497bfd;
  }

  .is-mobile .header-menu-navigation-item a {
    padding: 15px;
  }

  .is-mobile .header-menu-navigation-service {
    padding-bottom: 30px;
  }

  .is-mobile .header-menu-navigation-user {
    padding-top: 30px;
  }
}
</style>
